// extracted by mini-css-extract-plugin
module.exports = {"newsList":"NewsList_newsList__TGpST","moreNews":"NewsList_moreNews__OCLiB"};